import {Chart} from "chart.js";
import './mobile-menu.ts';

namespace ChartAnimation {

  /**
   * Draws a circle with a percentage higlighted
   * 
   * @param elementId The id of a canvas element
   * @param ratio The factor of the circle that has to be highlighted (0..1).
   */
  function circle(elementId: string, ratio: number) {

    const options = {
      type: 'doughnut',
      data: {
        datasets: [{
          data: [100*ratio, (100-100*ratio)],
          backgroundColor: [],
          borderWidth: 0
        }]
      },
      options: {
        cutoutPercentage: 90,
        responsive: true,
        events: []
      }
    }

    setColor(elementId, options);

    const chart = new Chart(elementId, options);
  }


  function setColor(elementId: string, options: Chart.ChartConfiguration) {
    // Get color scheme
    const p0 = document.getElementById(elementId);
    const p1 = p0.parentElement;
    const p2 = p1.parentElement;
    const p3 = p2.parentElement;
    const p4 = p3.parentElement;
    const p5 = p4.parentElement;
    const p6 = p5.parentElement;

    const isBrightDestkop = 
      window.matchMedia('(min-width: 992px)').matches &&
      p6.classList.contains('bright');

    if (isBrightDestkop) {
      options.data.datasets[0].backgroundColor = [
        'rgba(49, 57, 69, 1)',
        'rgba(49, 57, 69, 0.2)',
      ];
    }
    else {
      options.data.datasets[0].backgroundColor = [
        '#0CC2AA',
        'rgba(90, 225, 187, 0.2)'
      ];
    }
  }


  function windowWatcher() {
    
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    mediaQuery.addListener(mqListener);
    mqListener(mediaQuery);

    function mqListener(mediaQuery: MediaQueryList | MediaQueryListEvent) {
      for (const canvas of a(document.querySelectorAll('canvas'))) {
        init(canvas.id);
      }
    }
  }


  /**
   * Initializes the observer element so that the animation starts if the element 
   * is in the viewport.
   * 
   * @param elementId The id of a canvas element
   */
  function init(elementId: string) {
    const element = <HTMLCanvasElement> document.getElementById(elementId);

    if (!element) return;

    const ratio = Number(element.dataset.ratio);
    const observer = new IntersectionObserver(
      () => circle(elementId, ratio), {threshold: 1}
    );
    observer.observe(element);
  }
  
  function a(elements: HTMLCollection | NodeListOf<Element>) {
    return Array.prototype.slice.call(elements);
  }

  // Init
  windowWatcher();

}





